import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'User confirmed ad linking',
  name: 'ad_linking_confirmed',
};

export default META;
